const appConstants = {
  MINIMIZE_SIDEBAR: "MINIMIZE_SIDEBAR",
  COLLAPSE_SIDEBAR: "COLLAPSE_SIDEBAR",
  TOGGLE_RIGHTBAR: "TOGGLE_RIGHTBAR",
  TOGGLE_FIXED_FOOTER: "TOGGLE_FIXED_FOOTER",
  TOGGLE_COLLAPSED_FOOTER: "TOGGLE_COLLAPSED_FOOTER",
  UPDATE_PAGE_HEADER: "UPDATE_PAGE_HEADER",
  UPDATE_BREADCRUMB_MENU_ITEMS: "UPDATE_BREADCRUMB_MENU_ITEMS",
  SHOW_TOAST: "SHOW_TOAST",
  HIDE_TOAST: "HIDE_TOAST"
};

export default appConstants;



// WEBPACK FOOTER //
// ./src/_constants/appConstants.js